import { render, staticRenderFns } from "./TransactionAccountingSmallDetails.vue?vue&type=template&id=28b662ce&"
import script from "./TransactionAccountingSmallDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionAccountingSmallDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports